module.exports = __webpack_public_path__ + "static/media/rachelCruser.245c9ff1.jpg";